import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupH2 } from '../../../../../../../redux/app/annex6-v2/groups/group-h';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupH2PreviewProps = OwnProps;

function Annex6V2GroupH2Preview(props: Annex6V2GroupH2PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupH2;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemH2P1, itemH2P2 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'H', '2', renderItemP1()],
            [null, null, '3', renderItemP2()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        return (
            <h4 className="font-medium uppercase">
                BDN Reference no - {itemH2P2.bdn}
            </h4>
        );
    }

    function renderItemP2() {
        return (
            <h4 className="font-medium uppercase">
                BDN disposed on {moment(itemH2P1.date).format('DD-MMM-YYYY')}{' '}
                (SMT)
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupH2Preview;
